var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512", "aria-hidden": "true" }, props),
    React.createElement(
      "title",
      null,
      "People"
    ),
    React.createElement("path", { d: "M96 224a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm448 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm32 32h-64c-18 0-33 7-45 19 40 22 69 62 75 109h66c18 0 32-14 32-32v-32c0-35-29-64-64-64zm-256 0a112 112 0 1 0 0-224 112 112 0 0 0 0 224zm77 32h-8a158 158 0 0 1-137 0h-9c-63 0-115 52-115 115v29c0 27 22 48 48 48h288c27 0 48-21 48-48v-29c0-63-52-115-115-115zm-224-13a64 64 0 0 0-45-19H64c-35 0-64 29-64 64v32c0 18 14 32 32 32h66c6-47 35-87 75-109z" })
  );
});